var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasPermissionEx("view") }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasPermissionEx("view"),
              expression: "hasPermissionEx('view')"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c(
              "div",
              { attrs: { id: "card-container" } },
              [
                _c("div", { staticClass: "input-form" }, [
                  _c("div", { staticClass: "card-design" }, [
                    _c("div", [
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("system.user.query")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "all-forms" }, [
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("channel.currencyFromText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "common.pleaseSelectText"
                                  ),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.queryParameter.currencyFrom,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.queryParameter,
                                      "currencyFrom",
                                      $$v
                                    )
                                  },
                                  expression: "queryParameter.currencyFrom"
                                }
                              },
                              _vm._l(this.currencyTypeOption, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.display_name,
                                    value: item.key
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("channel.currencyToText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "common.pleaseSelectText"
                                  ),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.queryParameter.currencyTo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.queryParameter,
                                      "currencyTo",
                                      $$v
                                    )
                                  },
                                  expression: "queryParameter.currencyTo"
                                }
                              },
                              _vm._l(this.currencyTypeOption, function(item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: {
                                    label: item.display_name,
                                    value: item.key
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "channel.currencyExchangeRateUpdateStateText"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "common.pleaseSelectText"
                                  ),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.queryParameter.apiUpdateState,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.queryParameter,
                                      "apiUpdateState",
                                      $$v
                                    )
                                  },
                                  expression: "queryParameter.apiUpdateState"
                                }
                              },
                              _vm._l(
                                this.currencyExchangeRateUpdateStateOptions,
                                function(item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      label: item.display_name,
                                      value: item.key
                                    }
                                  })
                                }
                              ),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("channel.updateTimeText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              staticClass: "filter-item",
                              attrs: {
                                clearable: "",
                                type: "datetimerange",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                "range-separator": "-",
                                "start-placeholder": _vm.$t("common.fromTime"),
                                "end-placeholder": _vm.$t("common.toTime")
                              },
                              model: {
                                value: _vm.timeList,
                                callback: function($$v) {
                                  _vm.timeList = $$v
                                },
                                expression: "timeList"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              plain: _vm.$store.getters.plainConf,
                              type: "info",
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleFilter }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.search")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "actions", staticStyle: { height: "60px" } },
                  [
                    _c("div", { staticClass: "otherActions" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "addEditOrDelete" }, [
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hasPermissionEx("add"),
                                  expression: "hasPermissionEx('add')"
                                }
                              ],
                              staticClass: "filter-item",
                              attrs: {
                                plain: _vm.$store.getters.plainConf,
                                type: "success",
                                icon: "el-icon-plus"
                              },
                              on: {
                                click: function($event) {
                                  _vm.addDialogVisible = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.add")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hasPermissionEx("delete"),
                                  expression: "hasPermissionEx('delete')"
                                }
                              ],
                              staticClass: "filter-item",
                              attrs: {
                                plain: _vm.$store.getters.plainConf,
                                type: "danger",
                                icon: "el-icon-delete"
                              },
                              on: { click: _vm.handleBatchDelete }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.batchDeleteText")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hasPermissionEx("update"),
                                  expression: "hasPermissionEx('update')"
                                }
                              ],
                              staticClass: "filter-item",
                              attrs: {
                                plain: _vm.$store.getters.plainConf,
                                type: "success",
                                icon: "el-icon-check"
                              },
                              on: { click: _vm.handleUpdateByApi }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "channel.batchUpdateCurrencyExchangeRateText"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasPermissionEx("view"),
                        expression: "hasPermissionEx('view')"
                      }
                    ],
                    key: _vm.tableKey,
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.list,
                      stripe: _vm.$store.getters.stripeConf,
                      border: _vm.$store.getters.borderConf
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "55" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.currencyFromText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertCurrencyCodeToName(
                                      scope.row.currencyFrom
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertCurrencyCodeToName(
                                            scope.row.currencyFrom
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.currencyToText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertCurrencyCodeToName(
                                      scope.row.currencyTo
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertCurrencyCodeToName(
                                            scope.row.currencyTo
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.currencyRateText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.rate
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.rate))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "channel.currencyExchangeRateUpdateStateText"
                        ),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertUpdateStateCodeToName(
                                      scope.row.apiUpdateState
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertUpdateStateCodeToName(
                                            scope.row.apiUpdateState
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("channel.updateTimeText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.updateTime
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.updateTime))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("common.operationText"),
                        align: "center",
                        width: "220"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("update"),
                                      expression: "hasPermissionEx('update')"
                                    }
                                  ],
                                  staticClass: "filter-item",
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    round: _vm.$store.getters.roundConf,
                                    size: "mini",
                                    type: "warning",
                                    icon: "el-icon-edit"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleUpdateCheck(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("common.update")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("delete"),
                                      expression: "hasPermissionEx('delete')"
                                    }
                                  ],
                                  staticClass: "filter-item",
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    round: _vm.$store.getters.roundConf,
                                    size: "mini",
                                    type: "danger",
                                    icon: "el-icon-delete"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDelete(scope.row.id)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("common.delete")) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermissionEx("view"),
                      expression: "hasPermissionEx('view')"
                    }
                  ],
                  attrs: {
                    total: _vm.total,
                    page: _vm.queryParameter.pageNum,
                    limit: _vm.queryParameter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.queryParameter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.queryParameter, "pageSize", $event)
                    },
                    pagination: _vm.getList
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dialog" },
                  [
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          id: "dialog",
                          visible: _vm.addDialogVisible,
                          width: "700px",
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.addDialogVisible = $event
                          },
                          closed: _vm.handleResetAdd
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card" },
                          [
                            _c("div", { staticClass: "card-title" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm.updatePayChannelFlag
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "channel.updateCurrencyExchangeRateText"
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.updatePayChannelFlag
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "channel.addCurrencyExchangeRateText"
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "close" }, [
                                _c("i", {
                                  staticClass: "el-icon-close",
                                  on: { click: _vm.handleResetAdd }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form",
                              {
                                ref: "addInformation",
                                attrs: {
                                  model: _vm.addInformationParameter,
                                  rules: _vm.rules,
                                  "label-width": "220px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.currencyFromText"),
                                      prop: "currencyFrom"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "filter-item",
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "common.pleaseSelectText"
                                          ),
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.addInformationParameter
                                              .currencyFrom,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addInformationParameter,
                                              "currencyFrom",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addInformationParameter.currencyFrom"
                                        }
                                      },
                                      _vm._l(this.currencyTypeOption, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.display_name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.currencyToText"),
                                      prop: "currencyTo"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "filter-item",
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "common.pleaseSelectText"
                                          ),
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.addInformationParameter
                                              .currencyTo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addInformationParameter,
                                              "currencyTo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addInformationParameter.currencyTo"
                                        }
                                      },
                                      _vm._l(this.currencyTypeOption, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.display_name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("channel.currencyRateText"),
                                      prop: "rate"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder:
                                          _vm.addInformationParameter.rate,
                                        min: "0",
                                        precision: "2"
                                      },
                                      model: {
                                        value: _vm.addInformationParameter.rate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "rate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.rate"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "channel.currencyExchangeRateUpdateStateText"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "filter-item",
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "common.pleaseSelectText"
                                          ),
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.addInformationParameter
                                              .apiUpdateState,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.addInformationParameter,
                                              "apiUpdateState",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "addInformationParameter.apiUpdateState"
                                        }
                                      },
                                      _vm._l(
                                        this
                                          .currencyExchangeRateUpdateStateOptions,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.display_name,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "confirm-button" },
                              [
                                _c(
                                  "el-button",
                                  { on: { click: _vm.handleReset } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("common.reset")) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.buttonLoading,
                                        expression: "buttonLoading"
                                      }
                                    ],
                                    attrs: {
                                      type: "primary",
                                      disabled: _vm.buttonLoading
                                    },
                                    on: { click: _vm.handleAdd }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("common.submit")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }